import { createSlice } from "@reduxjs/toolkit";
import {
  getFarmers,
  addFarmer,
  updateFarmer,
  deleteFarmer,
  farmerFilter,
} from "./actions/farmer";

const initialState = {
  farmer: null,
  farmers: null,
  total: 0,
  loading: false,
  isEditing: false,
  filteredFarmers: null,
};

export const farmerSlice = createSlice({
  name: "farmer",
  initialState,
  reducers: {
    setFarmer: (state, action) => {
      const farmer = state.farmers.find(
        (_farmer) => _farmer.id === action.payload
      );
      state.farmer = farmer;
    },
    setFarmerFromReconcile: (state, action) => {
      state.farmer = action.payload;
    },
    setIsEditing: (state, action) => {
      state.isEditing = action.payload;
    },
    resetFilteredFarmers: (state) => {
      state.filteredFarmers = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFarmers.pending, (state) => {
        state.loading = true;
      })
      .addCase(getFarmers.fulfilled, (state, action) => {
        state.loading = false;
        state.farmers = action.payload.data;
        state.total = action.payload.count;
      })
      .addCase(getFarmers.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(addFarmer.pending, (state) => {
        state.loading = true;
      })
      .addCase(addFarmer.fulfilled, (state, action) => {
        state.loading = false;
        window.location.hash = "#/profile/farmer";
      })
      .addCase(addFarmer.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(updateFarmer.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateFarmer.fulfilled, (state, action) => {
        state.loading = false;
        state.isEditing = false;
        state.farmer = action.payload;
      })
      .addCase(updateFarmer.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(deleteFarmer.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteFarmer.fulfilled, (state) => {
        state.loading = false;
        window.location.hash = "#/profile/farmer";
      })
      .addCase(deleteFarmer.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(farmerFilter.pending, (state) => {
        // something
      })
      .addCase(farmerFilter.fulfilled, (state, action) => {
        state.filteredFarmers = action.payload?.data;
      })
      .addCase(farmerFilter.rejected, (state) => {
        // something
      });
  },
});

export const {
  setFarmer,
  setFarmerFromReconcile,
  setIsEditing,
  setIsDeleting,
  resetFilteredFarmers,
} = farmerSlice.actions;

export default farmerSlice.reducer;
